import { connect } from 'react-redux';
import ToggleSection from '../../../../../common/components/ToggleSection/ToggleSection';
import { changeFieldOverviewScope } from '../data/actions';
import { getFieldworkTableScopeSelector } from '../data/selectors';

const mapStateToProps = state => ({
    toggleLabels: {
        left: 'ADTESTER',
        right: 'BPT',
        imageAlt: 'Overview Toggle Button',
    },
    contentScope: getFieldworkTableScopeSelector(state),
});

const mapDispatchToProps = {
    changeScope: changeFieldOverviewScope,
};

const ToggleSectionContainer = connect(mapStateToProps, mapDispatchToProps)(ToggleSection);

export default ToggleSectionContainer;
